<template>
  <form class="m-4 md:mx-8 md:mt-16">
      <section>
      <h1 class="px-4 md:px-8 py-2 text-2xl font-bold bg-primario text-gray-200 tracking-wide rounded-t">
        {{ $t("lang.msg.design") }}
      </h1>
      <div class="bg-white p-4 md:p-8">
        <div class="flex items-center flex-wrap lg:flex-no-wrap lg:space-x-8">
          <PlanningImages :id-comercial-request="comercialRequest.idComercialRequest" :cloned="comercialRequest.cloned" />

          <div class="w-full lg:max-w-lg grid grid-cols-1 gap-4">
            <p class="text-primario text-xl">
              <span>{{ concatTwoValues(comercialRequest.comercialRequestReference, comercialRequest.comercialRequestReferenceNumber) }}</span>
            </p>
            <InputWrapper :label="$t('lang.msg.signupDate')">
              <span>{{ comercialRequest.comercialRequestActivationDate|moment }}</span>
            </InputWrapper>
            <InputWrapper :label="$t('lang.msg.comercialRequest')">
              <span>{{ concatTwoValues(comercialRequest.comercialRequestReference, comercialRequest.comercialRequestReferenceNumber) }}</span>
            </InputWrapper>
            <InputWrapper :label="$t('lang.msg.internalSalesman')">
              <span>{{ concatTwoValues(comercialRequest.employeeName, comercialRequest.employeeLastName) }}</span>
            </InputWrapper>
            <InputWrapper :label="$t('lang.msg.comercialNecessityDate')" content="input">
              <v-date-picker
                v-model="comercialRequest.comercialRequestNeededDate"
                mode="single"
                title-position="left"
                :input-props="{
                  class: 'datepicker hover:border-blue-500',
                  placeholder: $t('lang.msg.comercialNecessityDate'),
                }"
              />
            </InputWrapper>

            <InputWrapper :label="$t('lang.msg.designNecessityDate')" content="input">
              <v-date-picker
                v-model="comercialRequest.comercialRequestDesignDelivery"
                mode="single"
                title-position="left"
                :input-props="{
                  class: 'datepicker hover:border-blue-500',
                  placeholder: $t('lang.msg.designNecessityDate'),
                }"
              />
            </InputWrapper>

            <div class="flex w-full space-x-2" v-if="hasRoles(['ADMIN', 'DIRECCIÓN', 'EQUIPO EUROPROSEM'])">
              <ButtonAction @action="() => isDiscontinueModalOpen = true" large>
                {{ $t("lang.msg.cancelDesign") }}
              </ButtonAction>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- === DATOS GENERALES DE LA SOLICITUD COMERCIAL (GENERAL DATA) === -->
      <br>
    <section class="mt-8">
      <div class="pointer px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t" v-on:click="collapse('general')">
        <h2>{{ $t("lang.msg.generalData") }}</h2>
          <span :class="{'toggled':collapsed.general}">▲</span>
      </div>
      <div v-if="collapsed.general" class="bg-white p-4 md:p-8 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8 xl:gap-4">
        <div class="space-y-4">
            <InputWrapper :label="$t('lang.msg.reference2')" content="input">
                <InputText v-model="comercialRequest.comercialRequestReference2" :name="$t('lang.msg.reference2')" />
            </InputWrapper>
          <InputWrapper :label="$t('lang.msg.internalReference')">
            <span>{{ concatTwoValues(comercialRequest.comercialRequestReference, comercialRequest.comercialRequestReferenceNumber) }}</span>
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.clientReference')" content="input">
            <InputText v-model="comercialRequest.comercialRequestClientReference" :name="$t('lang.msg.clientReference')" />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.internalSalesman')" content="input">
            <Select
              id="idEmployee"
              :data="employees"
              track-by="employeeName"
              track-by2="employeeLastName"
              v-model.number="comercialRequest.idEmployee"
              @change="changeEmployee($event)"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.clientGroup')" content="input">
            <InputText v-model="comercialRequest.groupName" :name="$t('lang.msg.clientGroup')" disabled />
          </InputWrapper>
        </div>

        <div class="space-y-4">
          <InputWrapper :label="$t('lang.msg.clientBrand')" content="input">
            <Select
              id="idClient"
              ref="idClient"
              :data="clients"
              track-by="clientName"
              :error="formHasErrors && !comercialRequest.idClient"
              v-model.number="comercialRequest.idClient"
              @change="filterPerClient($event)"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.clientDepartment')" content="input">
            <Select
              id="idSection"
              :data="sections"
              track-by="sectionName"
              v-model.number="comercialRequest.idSection"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.clientSalesman')" content="input">
            <Select
              id="idBuyer"
              :data="filteredBuyers"
              track-by="buyerName"
              track-by2="buyerLastName"
              v-model.number="comercialRequest.idBuyer"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.clientDesigner')" content="input">
            <Select
              id="idDesigner"
              :data="filteredDesigners"
              track-by="designerName"
              track-by2="designerLastName"
              v-model.number="comercialRequest.idClientDesigner"
            />
          </InputWrapper>
        </div>

        <div class="space-y-4">
            <InputWrapper :label="$t('lang.msg.clientDesigner')" content="input">
                <Select
                    id="idDesigner"
                    :data="filteredDesigners"
                    track-by="designerName"
                    track-by2="designerLastName"
                    v-model.number="comercialRequest.idClientDesigner"
                />
            </InputWrapper>
          <InputWrapper :label="$t('lang.msg.article')" content="input">
            <Select
              id="idSubfamilyArticle"
              :data="subfamilyArticles"
              :track-by="getLangLabel('subfamilyArticle')"
              v-model.number="comercialRequest.idSubfamilyArticle"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.collection')" content="input">
            <Select
              id="idCollection"
              :data="collections"
              :track-by="getLangLabel('collection')"
              v-model.number="comercialRequest.idCollection"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.season')" content="input">
            <Select
              id="idSeason"
              :data="seasons"
              :track-by="getLangLabel('season')"
              v-model.number="comercialRequest.idSeason"
            />
          </InputWrapper>
        </div>
      </div>
    </section>
    <!-- === DATOS GENERALES DE LA SOLICITUD COMERCIAL (GENERAL DATA) === -->

    <!-- === DATOS TÉCNICOS DE LA FICHA TÉCNICA === -->
      <br>
      <TechnicalData :id-design="idDesign">
      <InputWrapper :label="$t('lang.msg.baseColor')" content="input">
        <Select
          id="idBaseColor"
          ref="idBaseColor"
          :data="baseColors"
          :track-by="getLangLabel('baseColor')"
          :error="formHasErrors && !design.idBaseColor"
          v-model.number="design.idBaseColor"
        />
      </InputWrapper>
      <InputWrapper :label="$t('lang.msg.size')" content="input">
        <Select
          id="idSize"
          ref="idSize"
          :data="sizes"
          track-by="size"
          :error="formHasErrors && !design.idSize"
          v-model.number="design.idSize"
        />
      </InputWrapper>
    </TechnicalData>
<!--      === DESCIPCIÓN ===-->
      <br>
    <section>
      <div class="pointer px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide" v-on:click="collapse('description')">
        <h2>{{ $t("lang.msg.description") }}</h2>
          <span :class="{'toggled':collapsed.description}">▲</span>
      </div>
      <div class="bg-white p-4 md:p-8" v-if="collapsed.description">
        <textarea
          class="form-textarea w-full"
          v-model="comercialRequest.comercialRequestConcept"
          :placeholder="$t('lang.msg.writeADescription')"
        />
      </div>
    </section>

    <!-- === FOTOS === -->
      <br>
      <section class="bg-white mt-8 pb-8">
          <div class="pointer  pointer px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide" v-on:click="collapse('images')">
              <h2>Fotos</h2>
              <span :class="{'toggled':collapsed.images}">▲</span>
          </div>
          <div class="bg-white p-4 md:p-8 space-y-6" v-if="collapsed.images">
      <div class="grid grid-cols-1 xl:grid-cols-2 gap-2">
        <div>
          <div class="px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t">
            <h2>{{ $t("lang.msg.referencePhotos") }}</h2>
          </div>
          <vue-dropzone
            ref="referenceDropzone"
            id="referenceDropzone"
            :options="dropzoneOptions"
            @vdropzone-sending="sendingEventReferencia"
          />

          <div class="gallery">
            <ImageGallery
              v-for="(image, imageIndex) in design.referenceImages"
              :key="`image_${imageIndex}`"
              :url="image.ruta"
              :id-foto="image.idFoto"
              @image-deleted="referenceImageDeleted"
            />
          </div>
        </div>
        <div>
          <div class="px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t">
            <h2>{{ $t("lang.msg.filePhotos") }}</h2>
          </div>
          <vue-dropzone
            ref="fileDropzone"
            id="fileDropzone"
            :options="dropzoneOptions"
            @vdropzone-sending="sendingEventFoto"
          />

          <div class="gallery">
            <ImageGallery
              v-for="(image, imageIndex) in design.fileImages"
              :key="`image_${imageIndex}`"
              :url="image.ruta"
              :id-foto="image.idFoto"
              @image-deleted="fileImageDeleted"
            />
          </div>
        </div>
      </div>
      <div class="flex justify-center mt-8">
        <ButtonRedirect
          v-if="hasRoles(['ADMIN', 'DIRECCIÓN', 'EQUIPO EUROPROSEM'])"
          route="shipmentDesignControl"
          :params="{ idDesign: idDesign }"
          color="blue"
          small
        >
          Ver envío altas
        </ButtonRedirect>
      </div>
          </div>
    </section>

    <!-- ============ -->
    <!-- === TAGS === -->
    <!-- ============ -->
      <br>
      <Tags
      @change="onTagChange"
      v-model="design.tags"
      :id-comercial-request="comercialRequest.idComercialRequest"
    />

    <!-- =================== -->
    <!-- === COMENTARIOS === -->
    <!-- =================== -->
      <br>
      <section v-if="hasRoles(['ADMIN', 'DIRECCIÓN', 'EQUIPO EUROPROSEM'])">
      <div class="pointer px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t mt-8" v-on:click="collapse('comments')">
        <h2>{{ $t("lang.msg.comments") }}</h2>
          <span :class="{'toggled':collapsed.comments}">▲</span>
      </div>
      <Comments
          v-if="collapsed.comments"
        class="p-4 md:p-8"
        :comments="design.comen"
        @comment-added="commentAdded"
        :id-comercial-request="comercialRequest.idComercialRequest"
      />
    </section>

    <!-- ===================== -->
    <!-- === ENVIAR NOTIFICACIÓN === -->
    <!-- ===================== -->
      <br>
      <section v-if="hasRoles(['ADMIN', 'DIRECCIÓN', 'EQUIPO EUROPROSEM'])">
      <div class="pointer px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide" v-on:click="collapse('tasks')">
        <h2>{{ $t("lang.msg.assignTask") }}</h2>
          <span :class="{'toggled':collapsed.tasks}">▲</span>
      </div>
      <TaskAssign
          v-if="collapsed.tasks"
                  :id-origen-tarea="design.idDesign"
                  origen-tarea="design"
                  :referencia="referencia" />
    </section>
      <br>
    <section class="mt-8">
      <div class="bg-white p-4 md:p-8 space-y-2 rounded-sm">
        <div class="flex flex-col lg:flex-row lg:items-center items-start justify-between">
            <div class="flex ml-auto">
                <div>
                <Steps
                    :comercialToDesign="comercialRequest.comercialToDesign"
                    :designToSample="design.designToSample"
                    :sampleToProduction="false"
                />
                </div>
                <div class="flex flex-col">
                    <div>
                        <input
                            v-model="comercialRequest.comercialToDesignDate"
                            class="form-input w-full md:w-56 h-8 mr-4"
                            type="text"
                            disabled
                            name="comercialToDesignDate"
                        >
                        <input
                            v-model="comercialRequest.comercialToDesignUserName"
                            class="form-input w-full md:w-56 h-8"
                            type="text"
                            disabled
                        >
                    </div>
                    <div class="mt-6">
                    <input
                            v-model="design.designToSampleDate"
                            class="form-input w-full md:w-56 h-8 mr-4"
                            type="text"
                            disabled
                        >
                        <input
                            v-model="design.designToSampleUserName"
                            class="form-input w-full md:w-56 h-8"
                            type="text"
                            disabled
                        >
                    </div>
                    <div class="mt-8">
                        <ToggleButton :checked="design.designToSample" @change="toggleIsDesignOk">
                            {{ $t("lang.msg.designOK") }}
                        </ToggleButton>
                    </div>
                </div>
            </div>
          <div class="flex items-center my-2 lg:my-0 text-sm">
          </div>
          <div class="w-full md:w-auto my-2 md:my-0 space-y-4 md:space-y-0 space-x-0 md:space-x-4">
          </div>
        </div>
        <div class="flex flex-col lg:flex-row lg:items-center items-start justify-between">
          <div class="flex items-center my-2 lg:my-0 text-sm">
          </div>
          <div class="w-full md:w-auto my-2 md:my-0 space-y-4 md:space-y-0 space-x-0 md:space-x-4">
          </div>
        </div>
        <div class="flex flex-col md:flex-row justify-end space-y-2 md:space-y-0 space-x-0 md:space-x-4">
          <div class="w-full md:w-56">
            <ButtonAction @action="() => isCloneDesignModalOpen = true" large>
              {{ $t("lang.msg.cloneDesign") }}
            </ButtonAction>
          </div>
          <div class="w-full md:w-56">
            <ButtonAction @action="() => isDiscontinueModalOpen = true" large>
              {{ $t("lang.msg.deleteDesign") }}
            </ButtonAction>
          </div>
        </div>
        <div class="w-full flex flex-col md:flex-row justify-end space-y-2 md:space-y-0 space-x-0 md:space-x-4">
          <div class="w-full md:w-56">
            <ButtonAction @action="confirmStepToProduction" large>
              <span style="color:white;display:flex;flex-direction:row;align-items: center;padding: 0.5em">
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="28"
                    viewBox="0 0 30 28"
                    fill="white">
                    <path d="M14 14c0-2.203-1.797-4-4-4s-4 1.797-4 4 1.797 4 4 4 4-1.797 4-4zM26 22c0-1.094-0.906-2-2-2s-2 0.906-2 2c0 1.109 0.906 2 2 2 1.109 0 2-0.906 2-2zM26 6c0-1.094-0.906-2-2-2s-2 0.906-2 2c0 1.109 0.906 2 2 2 1.109 0 2-0.906 2-2zM20 12.578v2.891c0 0.203-0.156 0.438-0.359 0.469l-2.422 0.375c-0.125 0.406-0.297 0.797-0.5 1.188 0.438 0.625 0.906 1.203 1.406 1.797 0.063 0.094 0.109 0.187 0.109 0.313 0 0.109-0.031 0.219-0.109 0.297-0.313 0.422-2.063 2.328-2.516 2.328-0.125 0-0.234-0.047-0.328-0.109l-1.797-1.406c-0.391 0.203-0.781 0.359-1.203 0.484-0.078 0.797-0.156 1.656-0.359 2.422-0.063 0.219-0.25 0.375-0.469 0.375h-2.906c-0.219 0-0.438-0.172-0.469-0.391l-0.359-2.391c-0.406-0.125-0.797-0.297-1.172-0.484l-1.844 1.391c-0.078 0.078-0.203 0.109-0.313 0.109-0.125 0-0.234-0.047-0.328-0.125-0.406-0.375-2.25-2.047-2.25-2.5 0-0.109 0.047-0.203 0.109-0.297 0.453-0.594 0.922-1.172 1.375-1.781-0.219-0.422-0.406-0.844-0.547-1.281l-2.375-0.375c-0.219-0.031-0.375-0.234-0.375-0.453v-2.891c0-0.203 0.156-0.438 0.359-0.469l2.422-0.375c0.125-0.406 0.297-0.797 0.5-1.188-0.438-0.625-0.906-1.203-1.406-1.797-0.063-0.094-0.109-0.203-0.109-0.313s0.031-0.219 0.109-0.313c0.313-0.422 2.063-2.312 2.516-2.312 0.125 0 0.234 0.047 0.328 0.109l1.797 1.406c0.391-0.203 0.781-0.359 1.203-0.5 0.078-0.781 0.156-1.641 0.359-2.406 0.063-0.219 0.25-0.375 0.469-0.375h2.906c0.219 0 0.438 0.172 0.469 0.391l0.359 2.391c0.406 0.125 0.797 0.297 1.172 0.484l1.844-1.391c0.094-0.078 0.203-0.109 0.313-0.109 0.125 0 0.234 0.047 0.328 0.125 0.406 0.375 2.25 2.063 2.25 2.5 0 0.109-0.047 0.203-0.109 0.297-0.453 0.609-0.922 1.172-1.359 1.781 0.203 0.422 0.391 0.844 0.531 1.281l2.375 0.359c0.219 0.047 0.375 0.25 0.375 0.469zM30 20.906v2.188c0 0.234-2.016 0.453-2.328 0.484-0.125 0.297-0.281 0.562-0.469 0.812 0.141 0.313 0.797 1.875 0.797 2.156 0 0.047-0.016 0.078-0.063 0.109-0.187 0.109-1.859 1.109-1.937 1.109-0.203 0-1.375-1.563-1.531-1.797-0.156 0.016-0.313 0.031-0.469 0.031s-0.313-0.016-0.469-0.031c-0.156 0.234-1.328 1.797-1.531 1.797-0.078 0-1.75-1-1.937-1.109-0.047-0.031-0.063-0.078-0.063-0.109 0-0.266 0.656-1.844 0.797-2.156-0.187-0.25-0.344-0.516-0.469-0.812-0.313-0.031-2.328-0.25-2.328-0.484v-2.188c0-0.234 2.016-0.453 2.328-0.484 0.125-0.281 0.281-0.562 0.469-0.812-0.141-0.313-0.797-1.891-0.797-2.156 0-0.031 0.016-0.078 0.063-0.109 0.187-0.094 1.859-1.094 1.937-1.094 0.203 0 1.375 1.547 1.531 1.781 0.156-0.016 0.313-0.031 0.469-0.031s0.313 0.016 0.469 0.031c0.438-0.609 0.906-1.219 1.437-1.75l0.094-0.031c0.078 0 1.75 0.984 1.937 1.094 0.047 0.031 0.063 0.078 0.063 0.109 0 0.281-0.656 1.844-0.797 2.156 0.187 0.25 0.344 0.531 0.469 0.812 0.313 0.031 2.328 0.25 2.328 0.484zM30 4.906v2.187c0 0.234-2.016 0.453-2.328 0.484-0.125 0.297-0.281 0.562-0.469 0.812 0.141 0.313 0.797 1.875 0.797 2.156 0 0.047-0.016 0.078-0.063 0.109-0.187 0.109-1.859 1.109-1.937 1.109-0.203 0-1.375-1.563-1.531-1.797-0.156 0.016-0.313 0.031-0.469 0.031s-0.313-0.016-0.469-0.031c-0.156 0.234-1.328 1.797-1.531 1.797-0.078 0-1.75-1-1.937-1.109-0.047-0.031-0.063-0.078-0.063-0.109 0-0.266 0.656-1.844 0.797-2.156-0.187-0.25-0.344-0.516-0.469-0.812-0.313-0.031-2.328-0.25-2.328-0.484v-2.188c0-0.234 2.016-0.453 2.328-0.484 0.125-0.281 0.281-0.562 0.469-0.812-0.141-0.313-0.797-1.891-0.797-2.156 0-0.031 0.016-0.078 0.063-0.109 0.187-0.094 1.859-1.094 1.937-1.094 0.203 0 1.375 1.547 1.531 1.781 0.156-0.016 0.313-0.031 0.469-0.031s0.313 0.016 0.469 0.031c0.438-0.609 0.906-1.219 1.437-1.75l0.094-0.031c0.078 0 1.75 0.984 1.937 1.094 0.047 0.031 0.063 0.078 0.063 0.109 0 0.281-0.656 1.844-0.797 2.156 0.187 0.25 0.344 0.531 0.469 0.812 0.313 0.031 2.328 0.25 2.328 0.484z"></path>
                </svg>
                    <span class="md:ml-1">
              {{ $t("lang.msg.stepToProduction") }}
                    </span>
                </span>
            </ButtonAction>
          </div>
          <div class="w-full md:w-56">
            <ButtonAction @action="confirmUpdateDesign" large>
              <span style="color:white;display:flex;flex-direction:row;align-items: center;justify-content:center;padding: 0.5em">
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="28"
                    fill="white"
                    viewBox="0 0 24 28">
                    <path d="M6 24h12v-6h-12v6zM20 24h2v-14c0-0.297-0.266-0.938-0.469-1.141l-4.391-4.391c-0.219-0.219-0.828-0.469-1.141-0.469v6.5c0 0.828-0.672 1.5-1.5 1.5h-9c-0.828 0-1.5-0.672-1.5-1.5v-6.5h-2v20h2v-6.5c0-0.828 0.672-1.5 1.5-1.5h13c0.828 0 1.5 0.672 1.5 1.5v6.5zM14 9.5v-5c0-0.266-0.234-0.5-0.5-0.5h-3c-0.266 0-0.5 0.234-0.5 0.5v5c0 0.266 0.234 0.5 0.5 0.5h3c0.266 0 0.5-0.234 0.5-0.5zM24 10v14.5c0 0.828-0.672 1.5-1.5 1.5h-21c-0.828 0-1.5-0.672-1.5-1.5v-21c0-0.828 0.672-1.5 1.5-1.5h14.5c0.828 0 1.969 0.469 2.562 1.062l4.375 4.375c0.594 0.594 1.062 1.734 1.062 2.562z"></path>
                </svg>
                <span class="md:ml-1">
              {{ $t("lang.msg.save") }}
                </span>
                </span>
            </ButtonAction>
          </div>
        </div>
      </div>
    </section>
      <TheModal
          :open="isNextStepModalOpen"
          :title="$t('lang.msg.nextStep')"
          @close="!isNextStepModalOpen"
      >
          <template #body>
              <Confirmation :to="'Producción'"/>
          </template>
          <template #action>
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
              type="button"
              class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 hover:bg-green-700 text-base font-medium text-white shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150"
              @click="stepToProduction">Aceptar</button>
        </span>
          </template>
      </TheModal>
    <TheModal :open="isCloneDesignModalOpen" :title="$t('lang.msg.cloneDesign')" @close="isCloneDesignModalOpen = false">
      <template #body>
        <p class="mt-4 pr-16 text-gray-700 font-semibold">
          {{ $t('lang.msg.preserverFactoryAndClient') }}
        </p>
      </template>
      <template #action>
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 hover:bg-green-700 text-base font-medium text-white shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150"
            @click="cloneDesign(true)"
          >{{ $t('lang.msg.preserve') }}</button>
        </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:ml-3 sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 hover:bg-red-700 text-base font-medium text-white shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150"
            @click="cloneDesign(false)"
          >{{ $t('lang.msg.dontPreserve') }}</button>
        </span>
      </template>
    </TheModal>
    <TheModal
        :open="confirmUpdateDesignModal"
        :title="$t('lang.msg.nextStep')"
        @close="confirmUpdateDesignModal=false"
    >
      <template #body>
        ¿Guardar el diseño?
      </template>
      <template #action>
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
              type="button"
              class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 hover:bg-green-700 text-base font-medium text-white shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150"
              @click="updateDesign">Aceptar</button>
        </span>
      </template>
    </TheModal>
    <TheModal :open="isDiscontinueModalOpen" :title="$t('lang.msg.discontinue')" @close="isDiscontinueModalOpen = false">
      <template #body>
        <p class="mt-4 pr-16 text-gray-700 font-semibold">
          {{ $t('lang.msg.discontinueDesign') }}
        </p>
        <textarea
          rows="2"
          class="form-textarea w-full mt-2"
          placeholder="Escriba el motivo aquí"
          v-model="cancellationReason"
        />
      </template>
      <template #action>
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 hover:bg-red-700 text-base font-medium text-white shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150"
            @click="discontinueDesign"
          >{{ $t('lang.msg.discontinue') }}</button>
        </span>
      </template>
    </TheModal>
  </form>
</template>

<script>
// MIXINS
import CalendarMixin from "@/components/mixins/CalendarMixin";
import UtilsMixin from "@/components/mixins/UtilsMixin";

// SECTIONS
import Tags from "@/components/shared/sections/Tags";
import TechnicalData from "@/components/shared/sections/TechnicalData";
import Comments from "@/components/Comments";
import TaskAssign from "@/components/TaskAssign";

// DROPZONE
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

// MODAL
import TheModal from "@/components/shared/TheModal";
import Confirmation from "@/components/modals/Confirmation";
import Steps from "@/components/Steps";

export default {
  name: "NewDesign",
  components: {
      Steps,
    Tags,
    TechnicalData,
    Comments,
    TaskAssign,
    vueDropzone: vue2Dropzone,
    TheModal,
      Confirmation
  },
  mixins: [CalendarMixin, UtilsMixin],
  data() {
    return {
      isCloneDesignModalOpen: false,
      idDesign: 0,
      design: {
        designToSampleUserName: ""
      },
      comercialRequest: {
        idComercialRequest: 0
      },
      // DROPZONE
      dropzoneOptions: {
        timeout: 120000,
        maxFilesize: 2048,
        url: `${this.$API_URL}/api/FileUpload/FotoReferenciaFichaUpload`,
        thumbnailWidth: 175,
        thumbnailHeight: 175,
        paramName: "files"
      },
      // MODAL
      isDiscontinueModalOpen: false,
      cancellationReason: "",
      // ERRORS
      formHasErrors: false,
      // TECHNICAL SHEET
      sizes: [],
      baseColors: [],
      // GENERAL DATA
      employees: [],
      buyers: [],
      clients: [],
      designers: [],
      collections: [],
      seasons: [],
      subfamilyArticles: [],
      sections: [],
      // FILTERS
      filteredBuyers: [],
      filteredDesigners: [],
      collapsed:{
          general:true,
          description:true,
          images:true,
          comments:true,
          tasks:true
      },
        isNextStepModalOpen:false,
      confirmUpdateDesignModal:false
    };
  },
  computed: {
    referencia() {
      return (
        this.comercialRequest.comercialRequestReference + '' +
        this.comercialRequest.comercialRequestReferenceNumber
      );
    }
  },
  created() {
    window.scrollTo(0, 0);
    this.idDesign = this.$route.params.idDesign;
    this.fetchData();
  },
  methods: {
      confirmStepToProduction(){
          this.isNextStepModalOpen = true;
      },
      collapse(section){
          this.collapsed[section]=!this.collapsed[section];
      },
    fetchData() {
      // Find the 'Design' by its idDesign.
      this.$axios
        .post(`api/Designs/GetDesign`, {
          idDesign: parseInt(this.idDesign)
        })
        .then((response) => {
          this.design = response.data[0];

          // Format the dates we got from the server.
          this.formatDateToString(this.design, [ "designToSampleDate" ]);

          // Fetch the 'ComercialRequest' after the 'Design' has been retrieved
          this.fetchGeneralData();
          this.fetchComercialRequest();
        });
    },
    fetchComercialRequest() {
      let langParams = { lang: this.language };
      let params     = { idComercialRequest: this.design.idComercialRequest };

      Promise.all([
        this.$axios.post(`api/ComercialRequests/GetThisComerRequest`, params),
        this.$axios.post(`api/Comments/GetAllComment`, params),
        this.$axios.post(`api/Tags/GetAllTag`, params),
        this.$axios.post(`api/BaseColors/GetBaseColor`, langParams),
        this.$axios.post(`api/Sizes/GetSize`, langParams)
      ]).then((values) => {
        this.comercialRequest = values[0].data[0];
        this.design.comen = values[1].data || [];
        this.design.tags = values[2].data || [];

        this.baseColors = this.getActive(values[3].data, 'active');
        this.sizes = values[4].data.filter((el) => {
          return el.idSubfamilyArticle == this.design.idSubfamily && el.active;
        });

        // Formateamos las fechas de solicitud comercial.
        this.formatDateToString(this.comercialRequest, [ "comercialToDesignDate" ]);

        this.formatDatetimesToDates(this.comercialRequest, [
          "comercialRequestNeededDate",
          "comercialRequestDesignDelivery"
        ]);

        // Fetch comercialRequest images
        this.fetchImages();
      });
    },
    /**
     *  The function will load first every data needed.
     */
    fetchGeneralData() {
      let langParams = { lang: this.language };

      Promise.all([
        this.$axios.post(`api/Employees/GetBy`, {
          rolName: "COMERCIAL",
          lang: this.language
        }),
        this.$axios.get(`api/Buyers/GetAllBuyer`),
        this.$axios.get(`api/Clients/GetAllClient`),
        this.$axios.get(`api/Designers/GetDesigner`),
        this.$axios.post(`api/Collections/GetCollectionActive`, langParams),
        this.$axios.post(`api/Seasons/GetSeason`, langParams),
        this.$axios.post(`api/SubfamilyArticles/getSubfamilyArticle`, langParams),
        this.$axios.get(`api/Sections/getSection`)
      ])
        .then((values) => {
          this.employees = this.getActive(values[0].data, 'active');
          this.buyers = this.getActive(values[1].data, 'active');
          this.clients = this.getActive(values[2].data, 'active');
          this.designers = this.getActive(values[3].data, 'active');
          this.collections = this.getActive(values[4].data, 'collectionAction');
          this.seasons = this.getActive(values[5].data, 'seasonActive');
          this.subfamilyArticles = this.getActive(values[6].data, 'subfamilyArticleActive');
          this.sections = this.getActive(values[7].data, 'active');
        });
    },
    /**
     *  Sets the employee and modifies the idCompany variable.
     */
    changeEmployee(idEmployee) {
      if (idEmployee) {
        let employee = this.employees.find((el) => {
          return el.idEmployee == idEmployee;
        });

        this.$set(this.comercialRequest, "idCompany", employee.idCompany);
      }
    },
    /**
     *  Filters the 'Buyers' and 'Designers' when the 'Client' is selected.
     */
    filterPerClient(idClient) {
      if (idClient) {
        this.filteredBuyers = this.buyers.filter((buyer) => {
          return buyer.idClient == idClient;
        });

        this.filteredDesigners = this.designers.filter((designer) => {
          return designer.idClient == idClient;
        });

        let clientFound = this.clients.find(client => {
          return client.idClient == idClient
        });

        if (clientFound) {
          this.$set(this.comercialRequest, 'groupName', clientFound.groupName);
        }
      }
    },
    fetchImages() {
      this.$axios
        .post(`api/Fotoes/GetAllFoto`, {
          idComercialRequest: this.design.idComercialRequest
        })
        .then((response) => {
          let allImages = response.data;

          this.design.referenceImages = allImages.filter((element) => {
            return element.referencia;
          });

          let fileImages = allImages.filter((element) => {
            return element.referencia == false;
          });
          this.$set(this.design, "fileImages", fileImages);
        });
    },
    confirmUpdateDesign(){
      this.confirmUpdateDesignModal = true;
    },
    updateDesign() {
        this.confirmUpdateDesignModal = false;

        if (!this.design.idBaseColor || !this.design.idSize || !this.comercialRequest.idClient) {
        this.formHasErrors = true;

        // Scroll to Input with errors.
        this.$nextTick(() => {
          window.scrollTo(0, this.$refs.idBaseColor.$el.offsetTop - 300);
        });
      } else {
        // Hacemos un clon del objeto para no modificar las fechas originales.
        let designClone = { ...this.design };
        this.formatStringsToDates(designClone, ["designToSampleDate"]);

        this.$axios
          .post("api/Designs/Update", {
            completado: true,
            idUser: this.user.id,
            comercialRequestReference: this.comercialRequest.comercialRequestReference,
            comercialRequestReferenceNumber: this.comercialRequest.comercialRequestReferenceNumber,
            idComercialRequest: this.comercialRequest.idComercialRequest,
            idDesign: parseInt(this.idDesign),
            idBaseColor: this.design.idBaseColor,
            idSize: this.design.idSize,
            designToSample: this.design.designToSample,
            designToSampleUser: this.design.designToSampleUser,
            designToSampleDate: designClone.designToSampleDate,
            concepto: this.comercialRequest.comercialRequestConcept
          })
          .then(() => {
            // Hacemos un clon del objeto para no modificar las fechas originales.
            let CRClone = { ...this.comercialRequest };
            this.formatStringsToDates(CRClone, ["comercialToDesignDate"]);

            // Format the comercialRequest dates before sending to the server.
            this.formatDatesToDatetimes(CRClone, [
              "comercialRequestNeededDate",
              "comercialRequestDesignDelivery"
            ]);

            // === UPDATE COMERCIAL REQUEST DATES. ===
            this.$axios
              .post("api/Designs/Fechas", {
                idComercialRequest: this.comercialRequest.idComercialRequest,
                comercialRequestNeededDate: CRClone.comercialRequestNeededDate,
                comercialRequestDesignDelivery: CRClone.comercialRequestDesignDelivery
              }).finally(() => {
                this.openAlert("success", "Diseño actualizado", null);
              });

            // === UPDATE GENERAL DATA ===
            this.$axios.post(`api/ComercialRequests/UpdateGeneral`, CRClone);
          });
      }
    },
    /**
     *  Paso a production con parámetros añadidos.
     */
    stepToProduction() {
      this.formatStringsToDates(this.design, ["designToSampleDate"]);

      this.$axios
        .post("api/Designs/DesignToProduction", {
          idDesign: this.design.idDesign,
          idDesigner: this.comercialRequest.idClientDesigner,
          idComercialRequest: this.design.idComercialRequest,
          idSize: this.design.idSize || null,
          idBaseColor: this.design.idBaseColor || null,
          sampleTaskSampleResolutionDate: "2020-01-01T00:00:00.000Z",
          productionTaskProductionEndDate: "2020-01-01T00:00:00.000Z",
          fechaEstimadaLlegada: "2020-01-01T00:00:00.000Z",
          fechaLlegadaReal: "2020-01-01T00:00:00.000Z",
          fechaEnvioFabrica: "2020-01-01T00:00:00.000Z",
          completado: this.design.idSize && this.design.idBaseColor ? true : false,
          idFactory: null,
          diseñador: null,
          idUser: this.user.id
        })
        .then(() => {
          this.$router.push({ name: "planningProduction" });
        });
    },
    toggleIsDesignOk(value) {
      if (value) {
        this.$set(this.design, "designToSampleDate", this.getCurrentDateAndHour());
        this.$set(this.design, "designToSampleUser", this.user.id);
        this.$set(this.design, "designToSampleUserName", this.user.fullname);
      } else {
        // If it returns false, then we empty their values
        this.$set(this.design, "designToSampleDate", "");
        this.$set(this.design, "designToSampleUser", null);
        this.$set(this.design, "designToSampleUserName", null);
      }

      this.$set(this.design, "designToSample", value);
    },
    cloneDesign(preserve) {
      let params = {
        idDesign: this.design.idDesign,
        idUser: this.user.id,
        designToSampleDate: "2020-01-01T00:00:00.000Z",
        comercialRequestDesignDelivery: "2020-01-01T00:00:00.000Z",
        comercialRequestNeededDate: "2020-01-01T00:00:00.000Z",
        comercialToDesignDate: "2020-01-01T00:00:00.000Z",
        preserve: preserve
      };

      // Convervar cliente al clonar diseño
      if (preserve) params.idClient = this.design.idClient;

      this.$axios.post("api/Clonations/ClonationsDesign", params).then(() => {
        this.isCloneDesignModalOpen = false;
        this.openAlert("success", "Diseño clonado", null);
        this.$router.push({ name: "planningDesign" });
      });
    },
    discontinueDesign() {
      this.$axios
        .post("api/Designs/Descatalogo", {
          idUser: this.user.id,
          idDesign: this.idDesign,
          designCancellationReason: this.cancellationReason
        })
        .then(() => {
          this.openAlert("success", "Diseño descatalogado", null);
          this.isDiscontinueModalOpen = false;
          this.cancellationReason = "";
        })
        .catch(() => this.showFriendlyError());
    },
    commentAdded(item) {
      this.design.comen.unshift(item);
    },
    onTagChange(array) {
      this.$set(this.design, "tags", array);
    },
    sendingEventReferencia(file, xhr, formData) {
      formData.append("referencia", true);
      formData.append("idComercialRequest", this.comercialRequest.idComercialRequest);
    },
    sendingEventFoto(file, xhr, formData) {
      formData.append("referencia", false);
      formData.append("idComercialRequest", this.comercialRequest.idComercialRequest);
    },
    referenceImageDeleted(idFoto) {
      let images = this.design.referenceImages.filter(image => {
        return image.idFoto != idFoto
      });

      this.$set(this.design, 'referenceImages', images);
      this.$forceUpdate();
    },
    fileImageDeleted(idFoto) {
      let images = this.design.fileImages.filter(image => {
        return image.idFoto != idFoto
      });

      this.$set(this.design, 'fileImages', images);
      this.$forceUpdate();
    }
  },
  watch: {
    design() {
      this.filterPerClient(this.comercialRequest.idClient);
    }
  }
};
</script>
